// Header wishlist link badge: shows how many products the visitor has saved in this browser.
const STORAGE_KEY = 'randaco:wishlist';

class SWishlistCount extends HTMLElement {
  connectedCallback() {
    this.badge = this.querySelector('[data-wishlist-count]');
    this.link = this.querySelector('a');
    this.update = () => this.render();
    this.onStorage = (event) => {
      if (event.key === STORAGE_KEY) this.render();
    };
    window.addEventListener('wishlist:change', this.update);
    window.addEventListener('storage', this.onStorage);
    this.render();
  }

  disconnectedCallback() {
    window.removeEventListener('wishlist:change', this.update);
    window.removeEventListener('storage', this.onStorage);
  }

  count() {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list.length : 0;
    } catch (error) {
      return 0;
    }
  }

  render() {
    const count = this.count();
    if (this.badge) {
      this.badge.textContent = count > 99 ? '99+' : String(count);
      this.badge.style.display = count > 0 ? 'flex' : 'none';
    }
    if (this.link && this.dataset.label) {
      this.link.setAttribute('aria-label', this.dataset.label.replace('__COUNT__', count));
    }
  }
}

if (!customElements.get('s-wishlist-count')) customElements.define('s-wishlist-count', SWishlistCount);
